import { RouterProvider, BrowserRouter as Router, Route, Navigate, Outlet, createBrowserRouter } from "react-router-dom";
import Home from "../pages/home/Home.tsx";
import Users from "../pages/users/Users.tsx";
import Organizations from "../pages/organizations/Organizations.tsx";
import Login from "../pages/login/Login.tsx";
import User from "../pages/user/User.tsx";
import Organization from "../pages/organization/Organization.tsx";
import Ressource from "../pages/ressource/Ressource.tsx";
import Ressources from "../pages/ressources/Ressources.tsx";

import { ProtectedRoute } from "./ProtectedRoute";
import { useAuth } from "../provider/authProvider.jsx";

//https://github.com/sanjay-arya/react-auth-demo/tree/main

const Routes = () => {
    const { token } = useAuth();
    const routesForAuthenticatedOnly = [
        {
            path: "/",
            element: <ProtectedRoute />,
            children: [
                {
                    path: "",
                    element: <Home />,
                },
                {
                    path: "/users",
                    element: <Users />
                },
                {
                    path: "/users/:id",
                    element: <User />
                }, {
                    path: "/organizations",
                    element: <Organizations />
                }, {
                    path: "/organizations/:id",
                    element: <Organization />
                },
                {
                    path: "/ressources",
                    element: <Ressources />
                }, 
                {
                    path: "/ressources/:id",
                    element: <Ressource />
                },
            ],
        },
    ];

    const routesForNotAuthenticatedOnly = [
        {
            path: "/login",
            element: <Login />
        }
    ];

    const routesForPublic = [
    ];

    const router = createBrowserRouter([
        ...routesForPublic,
        ...(!token ? routesForNotAuthenticatedOnly : []),
        ...routesForAuthenticatedOnly,
    ]);
    return <RouterProvider router={router} />;
}


export default Routes;